import $ from 'jquery';
import { getBreakpoints } from '../utils/utils';

const $listingDouble = $('.listing-double .tile-text__disclaimer');
const $listingTriple = $('.listing-triple .tile-text__disclaimer');

const breakPoint = getBreakpoints.lg;
let i = 1;

function setDisclaimerHeight(selector, cols) {
  let items = [];
  selector.each(function () {
    items.push($(this));
    if (i % cols === 0) {
      let disclaimerHeight = 0; let
        n;
      for (n = 0; n < items.length; n++) {
        if (items[n].outerHeight() > disclaimerHeight) {
          disclaimerHeight = items[n].outerHeight();
        }
      }
      for (n = 0; n < items.length; n++) {
        $(items[n]).css({ 'min-height': disclaimerHeight });
      }
      items = [];
    }
    i++;
  });
}

$(window).on('load resize', () => {
  if ($(window).width() < breakPoint) {
    return;
  }

  setDisclaimerHeight($listingDouble, 2);
  setDisclaimerHeight($listingTriple, 3);
});
export default true;
